// extracted by mini-css-extract-plugin
export var container = "_j1-0";
export var content = "_j1-3";
export var customerTitle = "_j1-4";
export var empty = "_j1-5";
export var gray = "_j1-6";
export var header = "_j1-7";
export var info = "_j1-8";
export var loading = "_j1-2";
export var loadingCard = "_j1-9";
export var oneLine = "_j1-a";
export var personName = "_j1-e";
export var pillContainer = "_j1-b";
export var selected = "_j1-1";
export var text = "_j1-c";
export var twoLines = "_j1-d";
export var unread = "_j1-f";
export var unreadIndicator = "_j1-g";